import $api from "@/api/ApiInteceptor";
import {
  ICabinet,
  IComission,
  IComissionCalc,
  ICommissionCalcPayload
} from "@/struct/IHomePage/ICabinetBalance";
import { EWebMethod } from "@/struct/IRequest/IRequest";

export default class ApiHome {
    public loadComissionCalc = false;

  public static async getTelegramConnect(): Promise<boolean> {
    try {
      const response = await $api.call(EWebMethod.GET, "/auth/is-telegram");
      return response.data;
    } catch (e) {
      return false;
    }
  }

  public static async getComission(
    commission_id: string,
  ): Promise<IComission[] | boolean> {
    try {
      const response = await $api.call(
        EWebMethod.GET,
        `/api/v1/commission/${commission_id}`,
      );
      return response.data;
    } catch (e) {
      return false;
    }
  }

  public static async getComissionCalc(
    payload: ICommissionCalcPayload,
  ): Promise<IComissionCalc | boolean> {
    try {
      const response = await $api.call(
        EWebMethod.GET,
        `/api/v4/mobile/driver/commission/calculation`,
        {
          commission_id: payload?.commission_id,
          card_id: payload?.card_id,
          cabinet_driver_id: payload?.cabinet_driver_id,
          amount: payload?.amount,
        },
      );
      return response.data;
    } catch (e) {
      return false;
    }
  }

  public static async getCabinets(): Promise<ICabinet[] | boolean> {
    try {
      const response = await $api.call(
        EWebMethod.GET,
        "/api/v5/mobile/driver/cabinets",
      );
      return response.data;
    } catch (e) {
      return false;
    }
  }

  public static async sendCreateTransaction(cabinet: string, amount: number) {
    try {
      const data = JSON.stringify({
        cabinet_id: cabinet,
        amount: amount,
      });
      const response = await $api.call(
        EWebMethod.POST,
        `/api/v4/mobile/driver/payout`,
        data,
      );
      return response.data;
    } catch (e) {
      return false;
    }
  }
}
